var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3-8h-2v1a1 1 0 0 1-2 0V4H6v1a1 1 0 0 1-2 0V4H2v10h12zm0 12H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2V1a1 1 0 0 1 2 0v1h4V1a1 1 0 0 1 2 0v1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"
  })));
};
export default SvgCalendar;